import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const getFavorites = async (token: string | null, showClosed: boolean = false) => {
    try {
        const query = showClosed ? "?showClosed=true" : "";
        const response = await axios.get(`${API_BASE_URL}/engagements/favorites${query}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching favorites:', error);
        throw error;
    }
};


export const deleteFavorite = async (engagementId: string, token: string | null) => {
    try {
        const response = await axios.delete(`${API_BASE_URL}/engagements/favorites/${engagementId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting favorite:', error);
        throw error;
    }
};
export const addOrUpdateFavorite = async (engagementId: string, token: string | null) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/engagements/favorites/${engagementId}`, {
            engagementId:engagementId
        },
            {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting favorite:', error);
        throw error;
    }
};

export const getFavoriteStatus = async (engagementId: string, token: string | null) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/engagements/favorite/${engagementId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting favorite:', error);
        throw error;
    }
};